import React from 'react';

import { observer } from 'mobx-react';

import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
// Hidden per LMP-5588
// import { NgzNotificationsSettings } from '../../../../guides-and-additional-info/containers/NgzNotificationsSettings/NgzNotificationsSettings';
import { EntityLoginIdBlock } from '../../entity-profile/containers/NgzLoginIdPasswordTab/containers/EntityLoginIdBlock/EntityLoginIdBlock';
import { EntityPasswordBlock } from '../../entity-profile/containers/NgzLoginIdPasswordTab/containers/EntityPasswordBlock/EntityPasswordBlock';

const SystemSettingsTab = observer(() => {
  const entityId = loggedInUserDataStore.getEntityId();
  const entityUserId = loggedInUserDataStore.loggedInUser!.id as number;

  return (
    <div>
      <EntityLoginIdBlock entityId={entityId} />
      <EntityPasswordBlock entityId={entityId} entityUserId={entityUserId} />
      {/* Hidden per LMP-5588: <NgzNotificationsSettings /> */}
    </div>
  );
});

export { SystemSettingsTab };
